const socialShareLinks = document.querySelectorAll('.social-share-link');
if (socialShareLinks) {
  [].forEach.call(socialShareLinks, anchor => {
    anchor.addEventListener('click', function click(e) {
      e.preventDefault();
      const y = window.outerHeight / 2 + window.screenY - 300 / 2;
      const x = window.outerWidth / 2 + window.screenX - 500 / 2;
      window.open(this.href, 'Share post', `width=500,height=300,top=${y},left=${x}`);
    });
  });
}
